"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Cont = require("../Control.Monad.Cont/index.js");
var Control_Monad_Cont_Trans = require("../Control.Monad.Cont.Trans/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_Monad_State_Trans = require("../Control.Monad.State.Trans/index.js");
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Show_Generic = require("../Data.Show.Generic/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Regex = require("../Data.String.Regex/index.js");
var Data_String_Regex_Flags = require("../Data.String.Regex.Flags/index.js");
var Data_String_Regex_Unsafe = require("../Data.String.Regex.Unsafe/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Void = require("../Data.Void/index.js");
var Effect = require("../Effect/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Haskell_Token = require("../Haskell.Token/index.js");
var Lexer_1 = require("../Lexer/index.js");
var Safe_Coerce = require("../Safe.Coerce/index.js");
var NoLayout = (function () {
    function NoLayout() {

    };
    NoLayout.value = new NoLayout();
    return NoLayout;
})();
var Feed = (function () {
    function Feed(value0) {
        this.value0 = value0;
    };
    Feed.create = function (value0) {
        return new Feed(value0);
    };
    return Feed;
})();
var Retry = (function () {
    function Retry() {

    };
    Retry.value = new Retry();
    return Retry;
})();
var LexVarId = (function () {
    function LexVarId(value0) {
        this.value0 = value0;
    };
    LexVarId.create = function (value0) {
        return new LexVarId(value0);
    };
    return LexVarId;
})();
var LexKeyword = (function () {
    function LexKeyword(value0) {
        this.value0 = value0;
    };
    LexKeyword.create = function (value0) {
        return new LexKeyword(value0);
    };
    return LexKeyword;
})();
var LexSymId = (function () {
    function LexSymId(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    LexSymId.create = function (value0) {
        return function (value1) {
            return new LexSymId(value0, value1);
        };
    };
    return LexSymId;
})();
var LexSpecial = (function () {
    function LexSpecial(value0) {
        this.value0 = value0;
    };
    LexSpecial.create = function (value0) {
        return new LexSpecial(value0);
    };
    return LexSpecial;
})();
var LexSCommentStart = (function () {
    function LexSCommentStart() {

    };
    LexSCommentStart.value = new LexSCommentStart();
    return LexSCommentStart;
})();

//
var LayoutState = function (x) {
    return x;
};
var TODO = (function () {
    function TODO() {

    };
    TODO.value = new TODO();
    return TODO;
})();
var NoLex = (function () {
    function NoLex() {

    };
    NoLex.value = new NoLex();
    return NoLex;
})();
var NoRetry = (function () {
    function NoRetry() {

    };
    NoRetry.value = new NoRetry();
    return NoRetry;
})();
var UnterminatedComment = (function () {
    function UnterminatedComment() {

    };
    UnterminatedComment.value = new UnterminatedComment();
    return UnterminatedComment;
})();
var MismatchedOpenBrace = (function () {
    function MismatchedOpenBrace() {

    };
    MismatchedOpenBrace.value = new MismatchedOpenBrace();
    return MismatchedOpenBrace;
})();
var MismatchedCloseBrace = (function () {
    function MismatchedCloseBrace() {

    };
    MismatchedCloseBrace.value = new MismatchedCloseBrace();
    return MismatchedCloseBrace;
})();
var Impossible = (function () {
    function Impossible(value0) {
        this.value0 = value0;
    };
    Impossible.create = function (value0) {
        return new Impossible(value0);
    };
    return Impossible;
})();
var Emit = (function () {
    function Emit(value0) {
        this.value0 = value0;
    };
    Emit.create = function (value0) {
        return new Emit(value0);
    };
    return Emit;
})();
var Empty = (function () {
    function Empty() {

    };
    Empty.value = new Empty();
    return Empty;
})();
var Fail = (function () {
    function Fail(value0) {
        this.value0 = value0;
    };
    Fail.create = function (value0) {
        return new Fail(value0);
    };
    return Fail;
})();
var Lexer = function (x) {
    return x;
};
var LexerState = (function () {
    function LexerState(value0) {
        this.value0 = value0;
    };
    LexerState.create = function (value0) {
        return new LexerState(value0);
    };
    return LexerState;
})();
var LexerEmpty = (function () {
    function LexerEmpty(value0) {
        this.value0 = value0;
    };
    LexerEmpty.create = function (value0) {
        return new LexerEmpty(value0);
    };
    return LexerEmpty;
})();
var ExtraState = function (emitToken) {
    this.emitToken = emitToken;
};
var Bail = function (x) {
    return x;
};
var withBail = function (k) {
    return function (bail) {
        return k(bail);
    };
};
var typeOfTag = function (v) {
    if (v instanceof Haskell_Token.Ident) {
        if (v.value0.type instanceof Haskell_Token.ConId) {
            var $94 = Data_Maybe.isJust(v.value0.qual);
            if ($94) {
                return "qconid";
            };
            return "conid";
        };
        if (v.value0.type instanceof Haskell_Token.VarId) {
            var $95 = Data_Maybe.isJust(v.value0.qual);
            if ($95) {
                return "qvarid";
            };
            return "varid";
        };
        if (v.value0.type instanceof Haskell_Token.ConSym) {
            var $96 = Data_Maybe.isJust(v.value0.qual);
            if ($96) {
                return "qconsym";
            };
            return "consym";
        };
        if (v.value0.type instanceof Haskell_Token.VarSym) {
            var $97 = Data_Maybe.isJust(v.value0.qual);
            if ($97) {
                return "qvarsym";
            };
            return "varsym";
        };
        throw new Error("Failed pattern match at Haskell.Lexer (line 118, column 14 - line 122, column 60): " + [ v.value0.type.constructor.name ]);
    };
    if (v instanceof Haskell_Token.ModId) {
        return "modid";
    };
    if (v instanceof Haskell_Token.Keyword) {
        return "keyword";
    };
    if (v instanceof Haskell_Token.PseudoKeyword) {
        return "pseudokeyword";
    };
    if (v instanceof Haskell_Token.Special) {
        return "special";
    };
    if (v instanceof Haskell_Token.LitInteger) {
        return "integer";
    };
    if (v instanceof Haskell_Token.LitFloat) {
        return "float";
    };
    if (v instanceof Haskell_Token.LitChar) {
        return "char";
    };
    if (v instanceof Haskell_Token.LitString) {
        return "string";
    };
    if (v instanceof Haskell_Token.Eof) {
        return "eof";
    };
    throw new Error("Failed pattern match at Haskell.Lexer (line 117, column 13 - line 131, column 15): " + [ v.constructor.name ]);
};
var spanFrom = function (from) {
    return function (to) {
        var diff = function (v) {
            return function (v1) {
                return v1.column - v.column | 0;
            };
        };
        return Data_String_CodePoints.take(diff(from.position)(to.position))(from.input);
    };
};
var runStream = (function () {
    var go = function ($copy_rtokens) {
        return function ($copy_v) {
            var $tco_var_rtokens = $copy_rtokens;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(rtokens, v) {
                if (v instanceof Empty) {
                    $tco_done = true;
                    return {
                        tokens: Data_List.reverse(rtokens),
                        error: Data_Maybe.Nothing.value
                    };
                };
                if (v instanceof Fail) {
                    $tco_done = true;
                    return {
                        tokens: Data_List.reverse(rtokens),
                        error: new Data_Maybe.Just(v.value0)
                    };
                };
                if (v instanceof Emit) {
                    $tco_var_rtokens = new Data_List_Types.Cons(v.value0.output, rtokens);
                    $copy_v = v["value0"]["continue"](Data_Unit.unit);
                    return;
                };
                throw new Error("Failed pattern match at Haskell.Lexer (line 83, column 5 - line 83, column 71): " + [ rtokens.constructor.name, v.constructor.name ]);
            };
            while (!$tco_done) {
                $tco_result = $tco_loop($tco_var_rtokens, $copy_v);
            };
            return $tco_result;
        };
    };
    return go(Data_List_Types.Nil.value);
})();
var runLexer_ = Safe_Coerce.coerce();
var rawToken = function (v) {
    return {
        value: v.value,
        position: v.position,
        tag: v.tag,
        type: typeOfTag(v.tag),
        before: [  ]
    };
};
var r = function (s) {
    return Data_String_Regex_Unsafe.unsafeRegex(s)(Data_String_Regex_Flags.unicode);
};
var reservedId = r("^(case|class|data|default|deriving|do|else|foreign|if|import|in|infix|infixl|infixr|instance|let|module|newtype|of|then|type|where|_)$");
var reservedOp = r("^([.][.]|:|::|=|\\\\|\\||<-|->|@|~|=>)$");
var restOfLine = r("^[^\\n]*");

// | @[\s]@ without @[\n]@.
//
// Reference on @[\s]@:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Character_Classes#types
var spaces = r("^[ \\f\\r\\t\\v\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000\\ufeff]+");
var special = r("^[(),;\\[\\]`{}]");
var varId = r("^[\\p{Ll}_][\\p{Ll}\\p{Lu}\\p{Lt}\\p{Nd}_']*");
var octal = r("^0[oO][0-7]+");
var monadStateLexer = Control_Monad_State_Trans.monadStateStateT(Control_Monad_Cont_Trans.monadContT(Data_Identity.monadIdentity));
var putLayoutState = function (l) {
    return Control_Monad_State_Class.modify_(monadStateLexer)(function (v) {
        var $110 = {};
        for (var $111 in v) {
            if ({}.hasOwnProperty.call(v, $111)) {
                $110[$111] = v[$111];
            };
        };
        $110.layout = l;
        return $110;
    });
};
var storeSubtoken = function (t) {
    return Control_Monad_State_Class.modify_(monadStateLexer)(function (s) {
        var $113 = {};
        for (var $114 in s) {
            if ({}.hasOwnProperty.call(s, $114)) {
                $113[$114] = s[$114];
            };
        };
        $113.revSubtokens = new Data_List_Types.Cons(t, s.revSubtokens);
        return $113;
    });
};
var monadLexer = Control_Monad_State_Trans.monadStateT(Control_Monad_Cont_Trans.monadContT(Data_Identity.monadIdentity));
var mkLexer = Safe_Coerce.coerce();
var orLex = function (lexTry) {
    return function (lexElse) {
        return mkLexer(function (s) {
            return function (k) {
                var l0 = Control_Monad_Reader_Trans.runReaderT(lexTry)(function (v) {
                    return runLexer_(lexElse)(s)(k);
                });
                return runLexer_(l0)(s)(k);
            };
        });
    };
};
var quit = mkLexer(function (v) {
    return function (v1) {
        return Empty.value;
    };
});
var mkGhost = function (value) {
    return function (position) {
        return {
            value: value,
            position: position,
            tag: new Haskell_Token.Special(true)
        };
    };
};
var isValidTag = function (s) {
    return Data_Array.elem(Data_Eq.eqString)(s)([ "qconid", "conid", "qvarid", "varid", "qconsym", "consym", "qvarsym", "varsym", "modid", "keyword", "special", "integer", "float", "char", "string", "eof" ]);
};
var hexa = r("^0[xX][\\p{Nd}a-fA-F]+");
var genericFailure = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof TODO) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof NoLex) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof NoRetry) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof UnterminatedComment) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
    };
    if (x instanceof MismatchedOpenBrace) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
    };
    if (x instanceof MismatchedCloseBrace) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
    };
    if (x instanceof Impossible) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
    };
    throw new Error("Failed pattern match at Haskell.Lexer (line 45, column 1 - line 45, column 52): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return TODO.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return NoLex.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return NoRetry.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return UnterminatedComment.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return MismatchedOpenBrace.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return MismatchedCloseBrace.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
        return new Impossible(x.value0.value0.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.Lexer (line 45, column 1 - line 45, column 52): " + [ x.constructor.name ]);
});
var showFailure = new Data_Show.Show(Data_Show_Generic.genericShow(genericFailure)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "TODO";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "NoLex";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "NoRetry";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "UnterminatedComment";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MismatchedOpenBrace";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MismatchedCloseBrace";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
    return "Impossible";
}))))))))));
var functorLexer = new Data_Functor.Functor(function (f) {
    return function (m) {
        return Data_Functor.map(Control_Monad_State_Trans.functorStateT(Control_Monad_Cont_Trans.functorContT(Data_Identity.functorIdentity)))(f)(m);
    };
});
var getLayoutState = Data_Functor.mapFlipped(functorLexer)(Control_Monad_State_Class.get(monadStateLexer))(function (v) {
    return v.layout;
});
var fail = function (e) {
    return mkLexer(function (v) {
        return function (v1) {
            return new Fail(e);
        };
    });
};
var nolex = fail(NoLex.value);
var exponent = r("^[eE][+-]?[0-9]+");
var escapeascii_ = "[^][][A-Z@\\\\^_]|NUL|SOH|STX|ETX|EOT|ENQ|ACK|BEL|BS|HT|LF|VT|FF|CR|SO|SI|DLE|DC1|DC2|DC3|DC4|NAK|SYN|ETB|CAN|EM|SUB|ESC|FS|GS|RS|US|SP|DEL";
var escape_ = "\\\\(?:[abfnrtv\\\\\"']|\\p{Nd}+|o[0-7]+|x[\\p{Nd}a-fA-F]+|" + (escapeascii_ + ")");
var enableLayout = {
    stack: Data_List_Types.Nil.value,
    prevToken: Data_Maybe.Nothing.value
};
var emit_ = function (t) {
    return Control_Monad_Trans_Class.lift(Control_Monad_State_Trans.monadTransStateT)(Control_Monad_Cont_Trans.monadContT(Data_Identity.monadIdentity))(Control_Monad_Cont.cont(function (k) {
        return new Emit({
            output: t,
            "continue": k,
            retry: function (v) {
                return new Fail(NoRetry.value);
            }
        });
    }));
};
var emitWithRetry = function (t) {
    return function (retry) {
        return mkLexer(function (s) {
            return function (k) {
                return new Emit({
                    output: t,
                    "continue": function (v) {
                        return k(new Data_Tuple.Tuple(Data_Unit.unit, s));
                    },
                    retry: function (v) {
                        return runLexer_(retry(Data_Unit.unit))(s)(k);
                    }
                });
            };
        });
    };
};
var emitToken = function (dict) {
    return dict.emitToken;
};
var decimal = r("^\\p{Nd}+");
var conId = r("^[\\p{Lu}\\p{Lt}][\\p{Ll}\\p{Lu}\\p{Lt}\\p{Nd}_']*");
var char_ = "(?:(?!['\\\\])[\\p{Ll}\\p{Lu}\\p{Lt}\\p{S}\\p{P}\\p{Nd} ]|" + (escape_ + ")");
var string = r("^\"" + (char_ + "+\""));
var $$char = r("^'" + (char_ + "'"));
var bye = function (v) {
    return mkLexer(function (v1) {
        return function (v2) {
            return v(Data_Unit.unit);
        };
    });
};
var bindLexer = Control_Monad_State_Trans.bindStateT(Control_Monad_Cont_Trans.monadContT(Data_Identity.monadIdentity));
var commitSubtoken = function (tag) {
    return function (pre) {
        return Control_Bind.bind(bindLexer)(Control_Monad_State_Class.get(monadStateLexer))(function (post) {
            var pspan = function (v) {
                return function (v1) {
                    return v1.column - v.column | 0;
                };
            };
            var value = Data_String_CodePoints.take(pspan(pre.position)(post.position))(pre.input);
            return storeSubtoken({
                value: value,
                tag: tag,
                position: pre.position
            });
        });
    };
};
var emitFrom = function (dictExtraState) {
    return function (pre) {
        return function (tag) {
            return Control_Bind.bind(bindLexer)(Data_Functor.map(functorLexer)(spanFrom(pre))(Control_Monad_State_Class.get(monadStateLexer)))(function (value) {
                return emitToken(dictExtraState)({
                    value: value,
                    position: pre.position,
                    tag: tag
                });
            });
        };
    };
};
var beginPosition = {
    line: 0,
    column: 0,
    ghosts: Data_Maybe.Nothing.value
};
var initialState = function (layout) {
    return function (input) {
        return {
            input: input,
            position: beginPosition,
            revSubtokens: Data_List_Types.Nil.value,
            layout: layout
        };
    };
};
var runLexer = function (lx) {
    return function (l) {
        return function (input) {
            return runLexer_(lx)(initialState(l)(input))(function (v) {
                return Data_Void.absurd(v.value0);
            });
        };
    };
};
var bailout = function (bail) {
    return mkLexer(function (v) {
        return function (v1) {
            return bail(Data_Unit.unit);
        };
    });
};
var lexEof = function (dictExtraState) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (s) {
        var $155 = s.input === "";
        if ($155) {
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(emitToken(dictExtraState)({
                value: "",
                position: s.position,
                tag: Haskell_Token.Eof.value
            }))(function () {
                return quit;
            }));
        };
        return bailout;
    });
};

// @ascSymbol@ without ":"
var ascSymbolLower = "[!#$%&\u22c6+./<=>?@\\\\^\\|~-]";
var ascSymbol = "[!#$%&\u22c6+./<=>?@\\\\^\\|~:-]";
var conSym = r("^:" + (ascSymbol + "*"));
var varSym = r("^" + (ascSymbolLower + (ascSymbol + "*")));
var applyLexer = Control_Monad_State_Trans.applyStateT(Control_Monad_Cont_Trans.monadContT(Data_Identity.monadIdentity));
var applicativeLexer = Control_Monad_State_Trans.applicativeStateT(Control_Monad_Cont_Trans.monadContT(Data_Identity.monadIdentity));
var commit = Control_Bind.bind(bindLexer)(Control_Monad_State_Class.get(monadStateLexer))(function (s) {
    return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(Control_Monad_State_Class.put(monadStateLexer)((function () {
        var $156 = {};
        for (var $157 in s) {
            if ({}.hasOwnProperty.call(s, $157)) {
                $156[$157] = s[$157];
            };
        };
        $156.revSubtokens = Data_List_Types.Nil.value;
        return $156;
    })()))(function () {
        return Control_Applicative.pure(applicativeLexer)(function (v) {
            return {
                value: v.value,
                position: v.position,
                tag: v.tag,
                type: typeOfTag(v.tag),
                before: Data_Array.reverse(Data_Array.fromFoldable(Data_List_Types.foldableList)(s.revSubtokens))
            };
        });
    });
});
var emit = function (t) {
    return Control_Bind.bind(bindLexer)(commit)(function (mkToken) {
        return emit_(mkToken(t));
    });
};
var extraStateNil = new ExtraState(emit);
var optional = function (a) {
    return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(orLex(Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(functorLexer))(Data_Maybe.Just.create)(a))(Control_Applicative.pure(applicativeLexer)(Data_Maybe.Nothing.value)));
};
var allDashes = r("^--+$");
var advanceLine = function (v) {
    return {
        line: v.line + 1 | 0,
        column: 0,
        ghosts: Data_Maybe.Nothing.value
    };
};
var lexNewline = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (s) {
    var v = Data_String_CodeUnits.stripPrefix("\x0a")(s.input);
    if (v instanceof Data_Maybe.Nothing) {
        return bailout;
    };
    if (v instanceof Data_Maybe.Just) {
        return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(Control_Monad_State_Class.put(monadStateLexer)((function () {
            var $166 = {};
            for (var $167 in s) {
                if ({}.hasOwnProperty.call(s, $167)) {
                    $166[$167] = s[$167];
                };
            };
            $166.input = v.value0;
            $166.position = advanceLine(s.position);
            return $166;
        })()))(function () {
            return storeSubtoken({
                value: "\x0a",
                tag: Haskell_Token.Newline.value,
                position: s.position
            });
        }));
    };
    throw new Error("Failed pattern match at Haskell.Lexer (line 220, column 3 - line 224, column 86): " + [ v.constructor.name ]);
});
var advanceGhost = function (v) {
    return {
        line: v.line,
        column: v.column,
        ghosts: new Data_Maybe.Just(Data_Maybe.maybe(0)(function (v2) {
            return v2 + 1 | 0;
        })(v.ghosts))
    };
};
var insertGhost = function (value) {
    return function ($265) {
        return (function (p$prime) {
            return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(emit(mkGhost(value)(p$prime)))(function () {
                return Control_Applicative.pure(applicativeLexer)(p$prime);
            });
        })(advanceGhost($265));
    };
};

// Also close any open brace.
var emitEofAndQuit = function (t) {
    return function (p0) {
        var close = function (ms) {
            return function (p) {
                if (ms instanceof Data_List_Types.Cons && ms.value0 instanceof Data_Maybe.Nothing) {
                    return fail(MismatchedOpenBrace.value);
                };
                if (ms instanceof Data_List_Types.Cons && ms.value0 instanceof Data_Maybe.Just) {
                    return Control_Bind.bind(bindLexer)(insertGhost("}")(p))(close(ms.value1));
                };
                if (ms instanceof Data_List_Types.Nil) {
                    return Control_Applicative.pure(applicativeLexer)(Data_Unit.unit);
                };
                throw new Error("Failed pattern match at Haskell.Lexer (line 611, column 20 - line 614, column 25): " + [ ms.constructor.name ]);
            };
        };
        return Control_Bind.bind(bindLexer)(getLayoutState)(function (l) {
            return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(close(l.stack)(p0))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(emit(t))(function () {
                    return quit;
                });
            });
        });
    };
};
var emitNow = function (t) {
    return function (v) {
        if (t.value === "{") {
            return Control_Bind.bind(bindLexer)(getLayoutState)(function (l) {
                return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
                    stack: new Data_List_Types.Cons(Data_Maybe.Nothing.value, l.stack),
                    prevToken: l.prevToken
                }))(function () {
                    return emit(t);
                });
            });
        };
        if (t.value === "}") {
            var go = function (p) {
                return Control_Bind.bind(bindLexer)(getLayoutState)(function (l) {
                    if (l.stack instanceof Data_List_Types.Cons && l.stack.value0 instanceof Data_Maybe.Nothing) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
                            stack: l.stack.value1,
                            prevToken: l.prevToken
                        }))(function () {
                            return emit(t);
                        });
                    };
                    if (l.stack instanceof Data_List_Types.Cons && l.stack.value0 instanceof Data_Maybe.Just) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
                            stack: l.stack.value1,
                            prevToken: l.prevToken
                        }))(function () {
                            return Control_Bind.bind(bindLexer)(insertGhost("}")(p))(go);
                        });
                    };
                    if (l.stack instanceof Data_List_Types.Nil) {
                        return fail(MismatchedCloseBrace.value);
                    };
                    throw new Error("Failed pattern match at Haskell.Lexer (line 588, column 7 - line 596, column 41): " + [ l.stack.constructor.name ]);
                });
            };
            return go(v);
        };
        return Control_Bind.bind(bindLexer)(commit)(function (mkToken) {
            return emitWithRetry(mkToken(t))(function (v1) {
                return Control_Bind.bind(bindLexer)(getLayoutState)(function (l) {
                    if (l.stack instanceof Data_List_Types.Cons && l.stack.value0 instanceof Data_Maybe.Just) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
                            stack: l.stack.value1,
                            prevToken: l.prevToken
                        }))(function () {
                            return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(emit_(mkToken(mkGhost("}")(t.position))))(function () {
                                return emitNow(t)(advanceGhost(v));
                            });
                        });
                    };
                    return fail(NoRetry.value);
                });
            });
        });
    };
};
var laNewline = function (t) {
    return function (n) {
        return function (p) {
            return Control_Bind.bind(bindLexer)(getLayoutState)(function (l) {
                if (l.stack instanceof Data_List_Types.Cons) {
                    if (Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(n)(l.stack.value0)) {
                        return insertGhost(";")(p);
                    };
                    if (Data_Ord.lessThan(Data_Maybe.ordMaybe(Data_Ord.ordInt))(n)(l.stack.value0)) {
                        return Control_Bind.bind(bindLexer)(insertGhost("}")(p))(function (p1) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
                                stack: l.stack.value1,
                                prevToken: l.prevToken
                            }))(function () {
                                return laNewline(t)(n)(p1);
                            });
                        });
                    };
                };
                return Control_Applicative.pure(applicativeLexer)(p);
            });
        };
    };
};
var laInsertBrace = function (t) {
    return function (n) {
        return Control_Bind.bind(bindLexer)(getLayoutState)(function (l) {
            if (l.stack instanceof Data_List_Types.Nil) {
                return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
                    stack: new Data_List_Types.Cons(n, Data_List_Types.Nil.value),
                    prevToken: l.prevToken
                }))(function () {
                    return insertGhost("{")(t.position);
                });
            };
            if (l.stack instanceof Data_List_Types.Cons && Data_Ord.lessThan(Data_Maybe.ordMaybe(Data_Ord.ordInt))(l.stack.value0)(n)) {
                return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
                    stack: new Data_List_Types.Cons(n, l.stack),
                    prevToken: l.prevToken
                }))(function () {
                    return insertGhost("{")(t.position);
                });
            };
            return Control_Bind.bind(bindLexer)(Control_Bind.bind(bindLexer)(insertGhost("{")(t.position))(insertGhost("}")))(laNewline(t)(n));
        });
    };
};
var advance = function (n) {
    return function (v) {
        return {
            line: v.line,
            column: v.column + n | 0,
            ghosts: Data_Maybe.Nothing.value
        };
    };
};
var consumeOne = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (s) {
    var v = Data_String_CodeUnits.uncons(s.input);
    if (v instanceof Data_Maybe.Nothing) {
        return bailout;
    };
    if (v instanceof Data_Maybe.Just) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.put(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer))((function () {
            var $201 = {};
            for (var $202 in s) {
                if ({}.hasOwnProperty.call(s, $202)) {
                    $201[$202] = s[$202];
                };
            };
            $201.input = v.value0.tail;
            $201.position = (function () {
                var $200 = v.value0.head === "\x0a";
                if ($200) {
                    return advanceLine(s.position);
                };
                return advance(1)(s.position);
            })();
            return $201;
        })()))(function () {
            return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(applicativeLexer))(v.value0.head);
        });
    };
    throw new Error("Failed pattern match at Haskell.Lexer (line 449, column 3 - line 455, column 16): " + [ v.constructor.name ]);
});
var exact = function (prefix) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (s) {
        var v = Data_String_CodeUnits.stripPrefix(prefix)(s.input);
        if (v instanceof Data_Maybe.Nothing) {
            return bailout;
        };
        if (v instanceof Data_Maybe.Just) {
            var n = Data_String_CodePoints.length(prefix);
            return Control_Monad_State_Class.put(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer))((function () {
                var $208 = {};
                for (var $209 in s) {
                    if ({}.hasOwnProperty.call(s, $209)) {
                        $208[$209] = s[$209];
                    };
                };
                $208.input = v.value0;
                $208.position = advance(n)(s.position);
                return $208;
            })());
        };
        throw new Error("Failed pattern match at Haskell.Lexer (line 423, column 3 - line 427, column 64): " + [ v.constructor.name ]);
    });
};

// | After "{-", errors are unrecoverable (no bailout).
var lexMCommentClose = function (n) {
    return function (pre) {
        var open = Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(exact("{-"))(function () {
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(lexMCommentClose(n + 1 | 0)(pre));
        });
        var close = Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(exact("-}"))(function () {
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)((function () {
                var $212 = n === 0;
                if ($212) {
                    return commitSubtoken(Haskell_Token.MComment.value)(pre);
                };
                return lexMCommentClose(n - 1 | 0)(pre);
            })());
        });
        var any = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(consumeOne)(function () {
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(lexMCommentClose(n)(pre));
        });
        return orLex(close)(orLex(open)(orLex(any)(fail(UnterminatedComment.value))));
    };
};
var lexMComment_ = function (pre) {
    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(exact("{-"))(function () {
        return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(lexMCommentClose(0)(pre));
    });
};
var lexMComment = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(lexMComment_);
var match = function (re) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (s) {
        var v = Data_String_Regex.match(re)(s.input);
        var v1 = function (v2) {
            return bailout;
        };
        if (v instanceof Data_Maybe.Just) {
            var $214 = Data_Array_NonEmpty.head(v.value0);
            if ($214 instanceof Data_Maybe.Just) {
                var n = Data_String_CodePoints.length($214.value0);
                return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.put(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer))((function () {
                    var $215 = {};
                    for (var $216 in s) {
                        if ({}.hasOwnProperty.call(s, $216)) {
                            $215[$216] = s[$216];
                        };
                    };
                    $215.input = Data_String_CodePoints.drop(n)(s.input);
                    $215.position = advance(n)(s.position);
                    return $215;
                })()))(function () {
                    return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(applicativeLexer))($214.value0);
                });
            };
            return v1(true);
        };
        return v1(true);
    });
};
var lexDecimal = function (dictExtraState) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (pre) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(decimal))(function () {
            var lexExp = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(exponent))(function () {
                return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitFrom(dictExtraState)(pre)(Haskell_Token.LitFloat.value));
            });
            var lexDot = Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(exact("."))(function () {
                return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(decimal))(function () {
                    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(optional(match(exponent)))(function () {
                        return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitFrom(dictExtraState)(pre)(Haskell_Token.LitFloat.value));
                    });
                });
            });
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(orLex(lexDot)(orLex(lexExp)(emitFrom(dictExtraState)(pre)(Haskell_Token.LitInteger.value))));
        });
    });
};
var matchSubtoken = function (tag) {
    return function (re) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(functorLexer))(function (v) {
            return v.position;
        })(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer))))(function (position) {
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(re))(function (value) {
                return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(storeSubtoken({
                    value: value,
                    tag: tag,
                    position: position
                }));
            });
        });
    };
};
var lexSpaces = matchSubtoken(Haskell_Token.Spaces.value)(spaces);
var matchSymId = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(withBail(function (bail) {
    return orLex(Data_Functor.mapFlipped(Control_Monad_Reader_Trans.functorReaderT(functorLexer))(match(varSym))(function (value) {
        return {
            value: value,
            tag: Haskell_Token.VarSym.value
        };
    }))(orLex(Data_Functor.mapFlipped(Control_Monad_Reader_Trans.functorReaderT(functorLexer))(match(conSym))(function (value) {
        return {
            value: value,
            tag: Haskell_Token.ConSym.value
        };
    }))(bye(bail)));
}))(function (v) {
    var $221 = Data_String_Regex.test(reservedOp)(v.value);
    if ($221) {
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(applicativeLexer))(new LexSpecial(v.value));
    };
    var $222 = Data_String_Regex.test(allDashes)(v.value);
    if ($222) {
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(applicativeLexer))(LexSCommentStart.value);
    };
    return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(applicativeLexer))(new LexSymId(v.value, v.tag));
});

// TODO: what if it is a qualified symbol?
var lexSym = function (dictExtraState) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (pre) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(matchSymId)(function (v) {
            if (v instanceof LexSymId) {
                return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitToken(dictExtraState)({
                    value: v.value0,
                    position: pre.position,
                    tag: new Haskell_Token.Ident({
                        name: v.value0,
                        qual: Data_Maybe.Nothing.value,
                        type: v.value1
                    })
                }));
            };
            if (v instanceof LexSpecial) {
                return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitToken(dictExtraState)({
                    value: v.value0,
                    position: pre.position,
                    tag: Haskell_Token.specialTag
                }));
            };
            if (v instanceof LexSCommentStart) {
                return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(restOfLine))(function () {
                    return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(commitSubtoken(Haskell_Token.SComment.value)(pre));
                });
            };
            throw new Error("Failed pattern match at Haskell.Lexer (line 345, column 18 - line 352, column 41): " + [ v.constructor.name ]);
        });
    });
};
var matchToken = function (dictExtraState) {
    return function (tag) {
        return function (re) {
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(functorLexer))(function (v) {
                return v.position;
            })(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer))))(function (position) {
                return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(re))(function (value) {
                    return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitToken(dictExtraState)({
                        value: value,
                        position: position,
                        tag: tag
                    }));
                });
            });
        };
    };
};
var lexChar = function (dictExtraState) {
    return matchToken(dictExtraState)(Haskell_Token.LitChar.value)($$char);
};
var lexNumber = function (dictExtraState) {
    return withBail(function (bail) {
        return orLex(matchToken(dictExtraState)(Haskell_Token.LitInteger.value)(hexa))(orLex(matchToken(dictExtraState)(Haskell_Token.LitInteger.value)(octal))(orLex(lexDecimal(dictExtraState))(bye(bail))));
    });
};
var lexSpecial = function (dictExtraState) {
    return matchToken(dictExtraState)(Haskell_Token.specialTag)(special);
};
var lexString = function (dictExtraState) {
    return matchToken(dictExtraState)(Haskell_Token.LitString.value)(string);
};
var matchVarId = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(varId))(function (value) {
    var $229 = Data_String_Regex.test(reservedId)(value);
    if ($229) {
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(applicativeLexer))(new LexKeyword(value));
    };
    return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(applicativeLexer))(new LexVarId(value));
});
var lexQualid = function (dictExtraState) {
    return function (pre) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (pre$prime) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(exact("."))(function () {
                var qual = new Data_Maybe.Just(spanFrom(pre)(pre$prime));
                var lexQVarId = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(matchVarId)(function (v) {
                    if (v instanceof LexVarId) {
                        return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitFrom(dictExtraState)(pre)(new Haskell_Token.Ident({
                            name: v.value0,
                            qual: qual,
                            type: Haskell_Token.VarId.value
                        })));
                    };
                    return bailout;
                });
                var lexQSymId = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(matchSymId)(function (v) {
                    if (v instanceof LexSymId) {
                        return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitFrom(dictExtraState)(pre)(new Haskell_Token.Ident({
                            name: v.value0,
                            qual: qual,
                            type: v.value1
                        })));
                    };
                    return bailout;
                });
                var lexQConId = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(conId))(function (name) {
                    return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(orLex(lexQualid(dictExtraState)(pre))(emitFrom(dictExtraState)(pre)(new Haskell_Token.Ident({
                        name: name,
                        qual: qual,
                        type: Haskell_Token.ConId.value
                    }))));
                });
                return withBail(function (bail) {
                    return orLex(lexQConId)(orLex(lexQVarId)(orLex(lexQSymId)(bye(bail))));
                });
            });
        });
    };
};
var lexCon = function (dictExtraState) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer)))(function (pre) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(match(conId))(function (value) {
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(orLex(lexQualid(dictExtraState)(pre))(emitToken(dictExtraState)({
                value: value,
                position: pre.position,
                tag: new Haskell_Token.Ident({
                    name: value,
                    qual: Data_Maybe.Nothing.value,
                    type: Haskell_Token.ConId.value
                })
            })));
        });
    });
};
var lexVar = function (dictExtraState) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(functorLexer))(function (v) {
        return v.position;
    })(Control_Monad_State_Class.get(Control_Monad_Reader_Trans.monadStateReaderT(monadStateLexer))))(function (position) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(bindLexer))(matchVarId)(function (v) {
            if (v instanceof LexKeyword) {
                return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitToken(dictExtraState)({
                    value: v.value0,
                    position: position,
                    tag: Haskell_Token.Keyword.value
                }));
            };
            if (v instanceof LexVarId) {
                return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(monadLexer)(emitToken(dictExtraState)({
                    value: v.value0,
                    position: position,
                    tag: new Haskell_Token.Ident({
                        name: v.value0,
                        qual: Data_Maybe.Nothing.value,
                        type: Haskell_Token.VarId.value
                    })
                }));
            };
            throw new Error("Failed pattern match at Haskell.Lexer (line 298, column 18 - line 302, column 69): " + [ v.constructor.name ]);
        });
    });
};
var lex_ = function (dictExtraState) {
    return orLex(lexNewline)(orLex(lexSpaces)(orLex(lexNumber(dictExtraState))(orLex(lexChar(dictExtraState))(orLex(lexString(dictExtraState))(orLex(lexSpecial(dictExtraState))(orLex(lexSym(dictExtraState))(orLex(lexCon(dictExtraState))(orLex(lexVar(dictExtraState))(orLex(lexEof(dictExtraState))(nolex))))))))));
};
var lex = function (dictExtraState) {
    return function (v) {
        return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(orLex(lexMComment)(lex_(dictExtraState)))(function () {
            return lex(dictExtraState)(Data_Unit.unit);
        });
    };
};
var hsStream = function (dictExtraState) {
    return runLexer(lex(dictExtraState)(Data_Unit.unit));
};
var actionBefore = function (v) {
    return Control_Bind.bind(bindLexer)(getLayoutState)(function (l) {
        return Control_Bind.discard(Control_Bind.discardUnit)(bindLexer)(putLayoutState({
            stack: l.stack,
            prevToken: new Data_Maybe.Just(v)
        }))(function () {
            if (l.prevToken instanceof Data_Maybe.Nothing && (v.value === "module" || v.value === "{")) {
                return laNewline(v)(new Data_Maybe.Just(v.position.column))(v.position);
            };
            var v1 = function (v2) {
                if (l.prevToken instanceof Data_Maybe.Nothing && Data_Boolean.otherwise) {
                    return laInsertBrace(v)(new Data_Maybe.Just(v.position.column));
                };
                if (l.prevToken instanceof Data_Maybe.Just && (Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqString)(l.prevToken.value0.value)([ "do", "let", "of", "where" ]) && v.value !== "{")) {
                    if (v.tag instanceof Haskell_Token.Eof) {
                        return Control_Bind.bind(bindLexer)(Control_Bind.bind(bindLexer)(insertGhost("{")(v.position))(insertGhost("}")))(emitEofAndQuit(v));
                    };
                    return laInsertBrace(v)(new Data_Maybe.Just(v.position.column));
                };
                var v3 = function (v4) {
                    if (l.prevToken instanceof Data_Maybe.Just) {
                        if (l.prevToken.value0.position.line < v.position.line) {
                            return laNewline(v)(new Data_Maybe.Just(v.position.column))(v.position);
                        };
                        if (Data_Boolean.otherwise) {
                            return Control_Applicative.pure(applicativeLexer)(v.position);
                        };
                    };
                    throw new Error("Failed pattern match at Haskell.Lexer (line 520, column 1 - line 520, column 55): " + [ l.prevToken.constructor.name ]);
                };
                if (l.prevToken instanceof Data_Maybe.Just) {
                    if (v.tag instanceof Haskell_Token.Eof) {
                        return emitEofAndQuit(v)(v.position);
                    };
                    return v3(true);
                };
                return v3(true);
            };
            if (l.prevToken instanceof Data_Maybe.Nothing) {
                if (v.tag instanceof Haskell_Token.Eof) {
                    return emitEofAndQuit(v)(v.position);
                };
                return v1(true);
            };
            return v1(true);
        });
    });
};
var extraStateLayoutState = new ExtraState(function (t) {
    return Control_Bind.bind(bindLexer)(actionBefore(t))(emitNow(t));
});
var lexer = Lexer_1.mkLexer({
    state: new LexerEmpty("Uninitialized lexer"),
    setInput: function (s) {
        return function (v) {
            if (v instanceof Retry) {
                if (s instanceof LexerState) {
                    return new LexerState({
                        "continue": s.value0.retry,
                        retry: function (v1) {
                            return new Fail(new Impossible("Retried retry"));
                        }
                    });
                };
                return s;
            };
            if (v instanceof Feed) {
                return new LexerState({
                    "continue": function (v1) {
                        return hsStream(extraStateLayoutState)(enableLayout)(v.value0);
                    },
                    retry: function (v1) {
                        return new Fail(new Impossible("Just started lexer"));
                    }
                });
            };
            throw new Error("Failed pattern match at Haskell.Lexer (line 631, column 22 - line 638, column 12): " + [ v.constructor.name ]);
        };
    },
    next: function (v) {
        if (v instanceof LexerState) {
            var v1 = v["value0"]["continue"](Data_Unit.unit);
            if (v1 instanceof Emit) {
                return Control_Applicative.pure(Effect.applicativeEffect)({
                    state: new LexerState({
                        "continue": v1["value0"]["continue"],
                        retry: v1.value0.retry
                    }),
                    token: new Data_Maybe.Just(v1.value0.output)
                });
            };
            if (v1 instanceof Empty) {
                return Control_Applicative.pure(Effect.applicativeEffect)({
                    state: new LexerEmpty("Done"),
                    token: Data_Maybe.Nothing.value
                });
            };
            if (v1 instanceof Fail) {
                return Effect_Exception["throw"](Data_Show.show(showFailure)(v1.value0));
            };
            throw new Error("Failed pattern match at Haskell.Lexer (line 640, column 23 - line 646, column 33): " + [ v1.constructor.name ]);
        };
        if (v instanceof LexerEmpty) {
            return Effect_Exception["throw"]("Should not happen: lexer in empty state: " + v.value0);
        };
        throw new Error("Failed pattern match at Haskell.Lexer (line 639, column 12 - line 647, column 79): " + [ v.constructor.name ]);
    },
    formatError: function (v) {
        return "TODO";
    },
    has: isValidTag
});
module.exports = {
    emitToken: emitToken,
    Emit: Emit,
    Empty: Empty,
    Fail: Fail,
    TODO: TODO,
    NoLex: NoLex,
    NoRetry: NoRetry,
    UnterminatedComment: UnterminatedComment,
    MismatchedOpenBrace: MismatchedOpenBrace,
    MismatchedCloseBrace: MismatchedCloseBrace,
    Impossible: Impossible,
    Lexer: Lexer,
    beginPosition: beginPosition,
    initialState: initialState,
    runStream: runStream,
    hsStream: hsStream,
    runLexer: runLexer,
    runLexer_: runLexer_,
    mkLexer: mkLexer,
    emit: emit,
    commit: commit,
    typeOfTag: typeOfTag,
    isValidTag: isValidTag,
    rawToken: rawToken,
    emit_: emit_,
    emitWithRetry: emitWithRetry,
    quit: quit,
    fail: fail,
    bailout: bailout,
    Bail: Bail,
    withBail: withBail,
    bye: bye,
    r: r,
    lex: lex,
    lexMComment: lexMComment,
    lexMComment_: lexMComment_,
    lexMCommentClose: lexMCommentClose,
    lex_: lex_,
    orLex: orLex,
    lexNewline: lexNewline,
    spaces: spaces,
    lexSpaces: lexSpaces,
    special: special,
    lexSpecial: lexSpecial,
    conId: conId,
    lexCon: lexCon,
    lexQualid: lexQualid,
    spanFrom: spanFrom,
    LexVarId: LexVarId,
    LexKeyword: LexKeyword,
    varId: varId,
    reservedId: reservedId,
    matchVarId: matchVarId,
    lexVar: lexVar,
    ascSymbol: ascSymbol,
    ascSymbolLower: ascSymbolLower,
    varSym: varSym,
    conSym: conSym,
    reservedOp: reservedOp,
    allDashes: allDashes,
    restOfLine: restOfLine,
    LexSymId: LexSymId,
    LexSpecial: LexSpecial,
    LexSCommentStart: LexSCommentStart,
    matchSymId: matchSymId,
    lexSym: lexSym,
    octal: octal,
    hexa: hexa,
    decimal: decimal,
    exponent: exponent,
    lexNumber: lexNumber,
    lexDecimal: lexDecimal,
    optional: optional,
    "char": $$char,
    string: string,
    char_: char_,
    escape_: escape_,
    escapeascii_: escapeascii_,
    lexChar: lexChar,
    lexString: lexString,
    lexEof: lexEof,
    nolex: nolex,
    exact: exact,
    match: match,
    matchToken: matchToken,
    consumeOne: consumeOne,
    ExtraState: ExtraState,
    emitFrom: emitFrom,
    NoLayout: NoLayout,
    storeSubtoken: storeSubtoken,
    matchSubtoken: matchSubtoken,
    commitSubtoken: commitSubtoken,
    advance: advance,
    advanceLine: advanceLine,
    LayoutState: LayoutState,
    enableLayout: enableLayout,
    getLayoutState: getLayoutState,
    putLayoutState: putLayoutState,
    actionBefore: actionBefore,
    laNewline: laNewline,
    laInsertBrace: laInsertBrace,
    insertGhost: insertGhost,
    advanceGhost: advanceGhost,
    mkGhost: mkGhost,
    emitNow: emitNow,
    emitEofAndQuit: emitEofAndQuit,
    Feed: Feed,
    Retry: Retry,
    LexerState: LexerState,
    LexerEmpty: LexerEmpty,
    lexer: lexer,
    genericFailure: genericFailure,
    showFailure: showFailure,
    functorLexer: functorLexer,
    applyLexer: applyLexer,
    applicativeLexer: applicativeLexer,
    bindLexer: bindLexer,
    monadLexer: monadLexer,
    monadStateLexer: monadStateLexer,
    extraStateNil: extraStateNil,
    extraStateLayoutState: extraStateLayoutState
};
